import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper("#js-homeProjectStorySwiper", {
  breakpoints: {
    768: {
      spaceBetween: 132,
    },
  },
  loop: true,
  pagination: {
    el: "#js-homeProjectStorySwiper .swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">0' + (index + 1) + "</span>";
    },
  },
  slidesPerView: "auto",
  spaceBetween: 0,
});
